import React, { useState, useEffect, useMemo, useRef } from 'react';
import { useLatest } from 'ahooks';
import Filter from '@/pages/intelligence/pages/TopCharts/components/CommonFilter';
import './index.scss';
import EditionsShareCard from './components/EditionsCard';
import CountriesCard from './components/CountriesCard';
import { DBI_TOPCHARTS } from '@/pages/intelligence/models/topcharts';
import TrendsCard from './components/TrendsCard';
import { getComputeType, getDefaultTime } from '@/pages/intelligence/utils/topchartsUtils';
import {
  getTopList,
  getMaketsType,
  getFixedTableData,
} from '../../utilsTmp/countryUtils';
import {
  statsActiveuserTrends,
  statsActiveuserEditionTable,
  statsActiveuserEditionTrend,
  statsActiveuserMarketTable,
  statsActiveuserMarketTrend,
} from '@/pages/intelligence/services/topcharts';
import { useIntl, connect, getLocale, history } from 'umi';
import { valueFormat, showTimeByDateType, isEmpty } from '@/pages/intelligence/utils/commonUtils';
import useEarliestTime from '../../utilsTmp/useEarliestTime';
import useFilterExtend from '@/pages/intelligence/hooks/useFilterExtend';
import {
  getMetricKey,
  // getEditionCountrytMetricKey,
} from './_config/utils';
import { sortTableByMetric } from '@/pages/intelligence/utils/tableUtils';
import { DownloadTitleTips } from '../_config';
import ExportTable from '../../../../../../../components/ExportTable';
import TipContext from '@/pages/home/components/TipContextComponents/TipContext';
import useChartDownloadHooks from '@/pages/intelligence/pages/TopCharts/_hooks/useChartDownloadHooks';
import { getDbiFilterParams } from '@intelligence/utils/filterUtils';
import {
  updateShortLinkFilterId,
  updateTimeFilterValue,
  URL_FILTER_KEY,
  URL_2_CHART_TYPE,
  URL_SHORT_LINK_NAME,
  URL_CHART_TYPE,
  URL_COUNTRIES_TYPE,
  URL_APP_IDS,
} from '@intelligence/utils/urlPathCfg';
import { useMobileDetailShortLink } from '@intelligence/pages/TopCharts/MobileGames/components/GamesDetails/Stats/_hook';
import { mobileStats } from '@intelligence/v3/constants/downloadLogPoint';
import { formatDateStrPlus } from '@intelligence/v3/utils/date';
import { appendAdjustedRevenueFilter } from '@intelligence/utils/revenueScope';
import * as filterKeyMap from '@/pages/intelligence/components/Filter/FilterBase/_config';
import MobileStatsRevenueScopePortal from './MobileStatsRevenueScopePortal';
import {
  buildCountriesChartDisplayList,
  buildCountriesTableDisplayList,
  buildCountriesChartRequestParams,
  getCountriesChartRequestMarketList,
} from '../_utils/countriesChartOthers';
import { getFirstWeekSinceReleaseDates, isFirstWeekSinceReleaseShortcut } from '../../utils';
import {
  MOBILE_STATS_OPINION_EVENT_FILTER_KEY,
  renderOpinionEventToolbar,
  useMobileStatsOpinionEvents,
} from '../useMobileStatsOpinionEvents';

const MOBILE_STATS_ACTIVE_USERS_TABLE_NODATA_KEY =
  'dbi_mobile_stats_active_users_table_nodata';

const buildStatsCardStatus = (
  status: { isLoading: boolean; isError: boolean; isNoData: boolean },
  pageId: string,
  isCoutriesPage: boolean,
) => {
  if (pageId === 'activeusers' && !isCoutriesPage) {
    return {
      ...status,
      noDataTextKey: MOBILE_STATS_ACTIVE_USERS_TABLE_NODATA_KEY,
    };
  }
  return status;
};

const ActiveUserContext = (props: any) => {
  const {
    isBasicLoading,
    loading,
    setLoading,
    topchartsState,
    tabType,
    pageId /** activeusers  revenue downloads*/,
    basicInfo,
    appIdListAll,
    unPublishedAppIdList,
    gameId,
    appIds,
    regionsCountries,
    isCalibrated,
    entityType,
    combineGameIdList,
    isTwoMonths,
    filterCfg,
    filterLoading,
    isCoutriesPage,
    shortLinkValidQuery,
    shortLinkFilterValue,
    urlCustomParams,
    showRankSwitch,
    chartSegment,
    enableRevenueScope = false,
  } = props;
  const pageIdLatest = useLatest<string>(pageId || '');
  const metricKey = getMetricKey(pageId);
  const getPageRequestParams = (params: any) => {
    if (pageIdLatest.current !== 'revenue') {
      return params;
    }

    const { adjusted_revenue, ...restParams } = params || {};
    return appendAdjustedRevenueFilter(restParams, restParams?.revenue_scope);
  };

  const { hasUrlShortLink } = filterCfg || {};
  const DEFAULT_FORM_VALUE = filterCfg?.defaultValue || [];
  const { formatMessage } = useIntl(); // 中英切换方法
  const locale = getLocale();
  const editionChartTypeRef = useRef('pie');
  const marketChartTypeRef = useRef('bar');
  const countryTypeRef = useRef('market');
  const [editionChartType, setEditionChartType] = useState<string>('pie');
  const [marketChartType, setMarketChartType] = useState<string>('bar');
  const [trendRankSwitch, setTrendRankSwitch] = useState(false);
  const [fetchParams, setFetchParams] = useState({
    app_ids: appIds,
    entity_type: entityType,
    region_type: 'region',
    regions: ['global'],
    source: isCalibrated ? 'ogdb' : 'sensortower',
    date_type: 'daily',
    start_date: '',
    end_date: '',
    metric: metricKey,
    region_type_share: 'market',
    platforms: ['googleplay', 'appstore'],
  });

  const [trendLineList, setTrendLineList] = useState<any>([]);
  const [trendTableList, setTrendTableList] = useState<any>([]);
  const [editionLineList, setEditionLineList] = useState<any>([]);
  const [lineData, setLineData] = useState<any>({});
  const [marketLineData, setMarketLineData] = useState<any>({});
  const [editionTableList, setEditionTableList] = useState<any>([]);
  const [marketTableList, setMarketTableList] = useState<any>([]);
  const [marketChartList, setMarketChartList] = useState<any>([]);
  const [trendLoading, setTrendLoading] = useState(loading);
  const [editionLoading, setEditionLoading] = useState(loading);
  const [chartLoading, setChartLoading] = useState(false);
  const [chartLineLoading, setChartLineLoading] = useState(false);

  const [topList, setTopList] = useState<any>(
    /* <TopListProp>*/ {
      total: {},
      global: {},
      globalWoChina: {},
      list: [],
    },
  );
  // 获取下架信息//TODO 从model里拿，存了没
  const isPullOffGame = topchartsState.islowerGame; // 下架的时间
  const pullOffTime = topchartsState.lowerGameTime; // 是否有下架时间的游戏
  // 掉榜游戏展示掉榜提示， 类似Nodata
  const [isDropdown, setIsDropdown] = useState(false);
  //   trend标题加上数据聚合方式
  const [trendComputeType, setTrendComputeType] = useState('');
  const [trendCount, setTrendCount] = useState('');
  // const [earliestPeriod, setEarliestPeriod] = useState('');
  const [trendError, setTrendError] = useState(false);
  const [editionError, setEditionError] = useState(false);
  const [marketError, setMarketError] = useState(false);
  const { isOperateDetail, detailFilterExtend, setDetailFilterExtend } = useFilterExtend({});
  const [editonFixedTableData, setEditionFixedTableData] = useState<any[]>([]);
  const [marketFixedTableData, setMarketFixedTableData] = useState<any[]>([]);
  const [filterValue, setFilterVale] = useState(
    isOperateDetail ? detailFilterExtend : DEFAULT_FORM_VALUE,
  );

  const {
    onTableSortChageTrend,
    onTableSortChageEdition,
    onTableSortChageCountrie,
    updateMobileDetailShortLink,
    updatePageCfgFromShortLink,
    trendPageSortAttr,
    editionPageSortAttr,
    countriesPageSortAttr,
  } = useMobileDetailShortLink({
    coutriesType: countryTypeRef.current,
    trendSortMetric: 'time',
    editionSortMetric: chartSegment,
    countrieSortMetric: chartSegment,
    shortLinkValidQuery,
    isCoutriesPage,
    marketChartType,
    editionChartType,
    setMarketChartType,
    setEditionChartType,
    trendRankSwitch: showRankSwitch ? trendRankSwitch : false,
    setTrendRankSwitch: showRankSwitch ? setTrendRankSwitch : () => {},
  });
  // 获取计算总数的类型字段
  const [marketType, setMarketType] = useState(
    getMaketsType(fetchParams.regions, fetchParams.regions),
  );

  // 获取可视化下载配置hooks
  const { chartDownloadConfig, setSumList, setTrendsChartDownList } = useChartDownloadHooks({
    locale,
    metricValue: pageId,
    source: fetchParams.source,
    dateType: fetchParams.date_type,
    entityType,
  });

  const { enableOpinionEvents, controlledEventAnnotation, opinionEventToolbar } =
    useMobileStatsOpinionEvents({
      pageId,
      tabType,
      isCoutriesPage,
      gameId,
      combineGameIdList,
      entityType,
      fetchParams,
      trendLineList,
    });
  const opinionEventToolbarRef = useRef(opinionEventToolbar);
  opinionEventToolbarRef.current = opinionEventToolbar;

  const filterCfgWithOpinionEvent = useMemo(() => {
    if (
      pageId !== 'revenue' ||
      !filterCfg?.filterKeyList?.includes(MOBILE_STATS_OPINION_EVENT_FILTER_KEY)
    ) {
      return filterCfg;
    }

    return {
      ...filterCfg,
      inputListExtras: {
        [MOBILE_STATS_OPINION_EVENT_FILTER_KEY]: {
          key: MOBILE_STATS_OPINION_EVENT_FILTER_KEY,
          visible: 1,
          render: () =>
            renderOpinionEventToolbar(opinionEventToolbarRef.current),
        },
      },
    };
  }, [filterCfg, pageId]);

  const {
    hasEarliestLogicInCurrentEntityType,
    setEarliestDay,
    earliestPeriod,
    setEarliestPeriod,
    earliestLoading,
    formattedEarliestDay,
    getEarliestDayAndEarliesPeriod,
    updateEarliestDateData,
    baseReleaseTimeValue,
    baseReleaseTimeData,
  } = useEarliestTime({
    entityType,
    basicInfo,
    appIds,
    dateType: fetchParams.date_type,
    topchartsState,
  });
  const firstWeekSinceReleaseDates = useMemo<string[]>(() => {
    if (!isFirstWeekSinceReleaseShortcut(topchartsState?.selectedTimeShortcutType)) {
      return [];
    }
    return getFirstWeekSinceReleaseDates({
      dateType: fetchParams?.date_type,
      startDate: fetchParams?.start_date,
      endDate: fetchParams?.end_date,
      releaseDate: baseReleaseTimeValue,
    });
  }, [
    topchartsState?.selectedTimeShortcutType,
    fetchParams?.date_type,
    fetchParams?.start_date,
    fetchParams?.end_date,
    baseReleaseTimeValue,
  ]);

  useEffect(() => {
    updatePageCfgFromShortLink();
    if (isCoutriesPage) {
      if (shortLinkValidQuery?.[URL_CHART_TYPE] !== undefined) {
        marketChartTypeRef.current = shortLinkValidQuery?.[URL_CHART_TYPE];
      }
      if (shortLinkValidQuery?.[URL_COUNTRIES_TYPE] !== undefined) {
        countryTypeRef.current = shortLinkValidQuery?.[URL_COUNTRIES_TYPE];
      }
    } else {
      if (shortLinkValidQuery?.[URL_2_CHART_TYPE] !== undefined) {
        editionChartTypeRef.current = shortLinkValidQuery?.[URL_2_CHART_TYPE];
      }
    }
  }, [shortLinkValidQuery]);

  useEffect(() => {
    if (!filterLoading && hasUrlShortLink) {
      updateMobileDetailShortLink();
    }
  }, [
    filterLoading,
    isCoutriesPage,
    editionChartType,
    marketChartType,
    countryTypeRef.current,
    trendRankSwitch,
  ]);

  useEffect(() => {
    // 是否请求完basic接口
    if (isBasicLoading || filterLoading) {
      // 选择单appid时要重新loading
      setLoading(true);
    } else {
      let newFetchParams = {
        ...fetchParams,
        metric: metricKey,
      };

      const hasUrlShortLinkVal = history.location.query?.[URL_SHORT_LINK_NAME];
      const { filterValue: newFilterValues, filterParams } = getDbiFilterParams({
        // urlFilter: any,
        urlCustomParams,
        urlShortLinkFilter: shortLinkFilterValue,
        filterSaveData: null,
        filterExtend: detailFilterExtend,
        specialParams: filterCfg?.specialParams,
        isOperate: isOperateDetail,
        filterName: '',
        filterKeyList: filterCfg?.filterKeyList ?? Object.keys(DEFAULT_FORM_VALUE),
      });

      if (Reflect.has(filterParams || {}, 'start_date')) {
        filterParams.start_date = formatDateStrPlus(filterParams.start_date);
      }
      if (Reflect.has(filterParams || {}, 'end_date')) {
        filterParams.end_date = formatDateStrPlus(filterParams.end_date);
      }

      // 如果有短链接，设置为继承模式
      if (isOperateDetail || hasUrlShortLinkVal) {
        // 如果目前是继承模式，就设置继承值为过滤后的筛选器值
        setDetailFilterExtend(newFilterValues);
      }
      setFilterVale(newFilterValues);
      newFetchParams = {
        ...newFetchParams,
        ...(urlCustomParams || {}),
        ...filterCfg?.handleFilterToApiParams(filterParams),
      };
      if (!appIds?.length) {
        setTrendLoading(false);
        setLoading(false);
        setEditionLoading(false);
        return;
      }
      getPageData(newFetchParams, newFilterValues);
      updateEarliestDateData({
        dataSources: [newFetchParams.source],
        metrics: [metricKey],
        regionType: newFetchParams.region_type,
        regions: newFetchParams.regions,
        dateType: newFetchParams.date_type,
        platforms: newFetchParams?.platforms,
      });
    }
  }, [isBasicLoading, pageId, filterLoading, shortLinkFilterValue]);

  const getPageData = (newFetchParams: any, updateFilterValues = filterValue) => {
    if (tabType === 'stats') {
      getStatsData(newFetchParams, updateFilterValues);
    } else if (isCoutriesPage) {
      getCountry(newFetchParams, countryTypeRef.current, updateFilterValues);
    } else {
      console.error(`tabType=${tabType} is not stats||countries!`);
    }
  };

  const getStatsData = async (params = fetchParams, updateFilterValues = filterValue) => {
    const newFetchParams = { ...fetchParams, ...params };
    newFetchParams.app_ids = appIds;
    setFetchParams(newFetchParams);
    // setReqParamsDownLoad({ ...newFetchParams });
    try {
      /** 接口速率优化：
       * 第一次时间为空时先请求trend获取时间后再请求channel；
       * 如果时间不为空，则可以同时请求2个接口
       */
      if (newFetchParams.start_date === '' || newFetchParams.end_date === '') {
        const { start_date, end_date } = await getTrends(newFetchParams);

        if (start_date && end_date) {
          newFetchParams.start_date = start_date;
          newFetchParams.end_date = end_date;
          getEdition(newFetchParams);
        } else {
          const [defautStart, defautEnd] = getDefaultTime(newFetchParams.date_type, isTwoMonths);
          newFetchParams.start_date = defautStart;
          newFetchParams.end_date = defautEnd;
          setEditionLoading(false);
        }
        setFetchParams(newFetchParams);

        const newFilterValue = updateTimeFilterValue({
          // hasUrlShortLinkVal,
          // haveFilterSaveBtn: false,
          // filterSaveName,
          filterValue: updateFilterValues,
          timeFilterValues: {
            type: newFetchParams.date_type,
            value: [newFetchParams.start_date, newFetchParams.end_date],
          },
        });
        setFilterVale(newFilterValue);
        if (hasUrlShortLink) {
          updateShortLinkFilterId({ [URL_FILTER_KEY]: newFilterValue, [URL_APP_IDS]: appIds });
        }
      } else {
        if (hasUrlShortLink) {
          updateShortLinkFilterId({ [URL_FILTER_KEY]: updateFilterValues, [URL_APP_IDS]: appIds });
        }
        getTrends(newFetchParams);
        getEdition(newFetchParams);
      }
    } catch (err) {
      console.error(err);
      setTrendLoading(false);
      setEditionLoading(false);
    }
  };

  const getTrends = async (params: any) => {
    setTrendLoading(true);
    setLoading(true);
    const newFetchParams = { ...fetchParams, ...params };
    setFetchParams(newFetchParams);
    // setReqParamsDownLoad({ ...newFetchParams });

    // eslint-disable-next-line no-prototype-builtins
    if (
      (newFetchParams?.hasOwnProperty('app_ids') && !newFetchParams.app_ids?.length) ||
      isEmpty(newFetchParams?.regions)
    ) {
      setTrendLineList([]);
      setTrendTableList([]);
      // setDateTimeDatas('month', '', '');
      setTrendLoading(false);
      setLoading(false);
      setTrendError(true);
      return {
        start_date: '',
        end_date: '',
      };
    }
    try {
      const trendRes = await statsActiveuserTrends(
        getPageRequestParams(newFetchParams),
      );

      const countData = trendRes?.data?.total || [];
      if (countData?.length > 0) {
        setTrendComputeType(getComputeType(countData[0].opt));
        setTrendCount(valueFormat(countData[0].value).toString());
      }
      const sumAvgList = trendRes?.data?.sum_avg || [];
      // 如果是需要提供可视化下载的metirc，需要调用此hooks方法，提供对应config数据
      if (Array.isArray(sumAvgList) && sumAvgList?.length > 0) {
        setSumList(sumAvgList);
      }

      const startDate = trendRes?.req?.start_date;
      const endDate = trendRes?.req?.end_date;
      const reqApi = {
        ...newFetchParams,
        start_date: startDate,
        end_date: endDate,
      };
      setIsDropdown(trendRes?.data?.b_drop_global || false);
      // setReqParamsDownLoad({ ...reqApi });
      setFetchParams({ ...reqApi });
      setTrendLineList(trendRes?.data?.trends || []);
      setTrendsChartDownList(trendRes?.data?.trends || []);
      setTrendTableList(trendRes?.data?.trends || []);
      // 给时间筛选器赋值
      // setDateTimeDatas('month', startDate, endDate);
      setTrendLoading(false);
      setLoading(false);
      setTrendError(false);
      return {
        start_date: startDate,
        end_date: endDate,
      };
    } catch (err) {
      setTrendLineList([]);
      setTrendTableList([]);
      // setDateTimeDatas('month', '', '');
      setTrendLoading(false);
      setLoading(false);
      setTrendError(true);
      return {
        start_date: '',
        end_date: '',
      };
    }
  };

  const getEdition = async (params: any) => {
    const newFetchParams = { ...fetchParams, ...params };
    setEditionLoading(true);

    // eslint-disable-next-line no-prototype-builtins
    if (newFetchParams.hasOwnProperty('app_ids') && !newFetchParams.app_ids?.length) {
      setEditionTableList([]);
      setEditionFixedTableData([]);
      setEditionError(true);
      setEditionLoading(false);
      return;
    }

    try {
      const editionRes = await statsActiveuserEditionTable(
        getPageRequestParams(newFetchParams),
      );
      if (editionRes?.code === 0 && !!editionRes?.data) {
        /** 将数据进行排序， 表格、柱状图排序展示， 可视化需要拿top5参数发给后端拿排序后的折线 */
        const dataList = editionRes?.data?.list || [];
        const totalIndex = dataList?.findIndex((t: any) => t?.app_id === 'total');
        const totalList = [];
        if (totalIndex > -1) {
          totalList.push(dataList[totalIndex]);
          dataList?.splice(totalIndex, 1);
        }
        const sortData = sortTableByMetric({
          tableData: dataList,
          sortParams: {
            ratioType: 0,
            sortVal: 'desc',
            sortMetric: metricKey,
          },
          timeProperty: 'time',
          metricProperty: 'metric',
          growthProperty: 'growth_ratio',
        });
        setEditionFixedTableData(totalList);
        // 从basicinfo接口中提取头像和platform
        const tableList: any[] = [];
        sortData?.forEach((item: any) => {
          const appIdItem = appIdListAll.filter((obj: any) => obj?.id === item.app_id);
          tableList.push(Object.assign(item, ...appIdItem));
        });
        setEditionTableList(tableList || []);
        // TODO total拆出来 ， 折线重新请求接口
        if (
          editionChartTypeRef.current === 'line' ||
          editionChartTypeRef.current === 'stackedLine'
        ) {
          const topAppids = getTopAppids(tableList || []);
          getEditionTrends(newFetchParams, topAppids, tableList);
        }
      } else {
        setEditionTableList([]);
      }
      setEditionError(false);
    } catch (err) {
      console.log(err);
      setEditionTableList([]);
      setEditionFixedTableData([]);
      setEditionError(true);
    }
    setEditionLoading(false);
  };

  // 组装rpd折线图数据
  const getRpdTypeData = (list: any) => {
    if (!Array.isArray(list) || list?.length < 1) return [];
    const arr: any = [];
    for (const i in list) {
      let dauData = {} as any;
      if (list[i].metrics && Array.isArray(list[i].metrics) && list[i].metrics?.length > 0) {
        if (pageId === 'activeusers') {
          dauData = list[i].metrics.find((item: any) => item.metric == 'dau');
        } else if (pageId === 'revenue') {
          dauData = list[i].metrics.find((item: any) => item.metric == 'revenue');
        } else if (pageId === 'downloads') {
          dauData = list[i].metrics.find((item: any) => item.metric == 'download');
        }
      }

      if (dauData) {
        arr.push({
          metric: dauData.metric,
          source: fetchParams.source,
          time: fetchParams?.date_type
            ? showTimeByDateType(list[i].time, fetchParams?.date_type?.toLocaleLowerCase())
            : '',
          value: dauData.value,
          predict: dauData.b_predict,
        });
      }
    }
    return arr;
  };

  const getEditionTrends = async (
    params = fetchParams,
    topAppid: string[] = [],
    tableList = editionTableList,
  ) => {
    const _apiData = { ...params, app_ids: topAppid };
    setEditionLoading(true);
    try {
      const res = await statsActiveuserEditionTrend(
        getPageRequestParams(_apiData),
      );
      // console.log('resresresresres', res);
      // console.log('editionTableList', editionTableList);
      const lineDataRes = res?.data?.trends || [];
      // 重组lineData , 将name 和 cover赋值给lineData
      // 组装数据为rpd一样
      const arrGameData: any = [];
      for (const n in lineDataRes) {
        if (lineDataRes[n].app_id !== 'total') {
          const gameObj =
            tableList?.find((item: any) => item.app_id == lineDataRes[n].app_id) || {};
          const objTemp = {
            cover: gameObj.cover,
            id: gameObj.app_id,
            name:
              (gameObj?.platform === 'android'
                ? `${gameObj?.name}(Google Play)`
                : gameObj?.platform === 'ios'
                ? `${gameObj?.name}(App Store)`
                : '') || '',
            history: getRpdTypeData(lineDataRes[n].time_line),
          };
          arrGameData.push(objTemp);
        }
      }
      const temp = {
        source: Array.isArray(arrGameData) ? arrGameData : [],
      };
      setLineData(temp);
      // setEditionLineList(lineListMetric || []);
      setEditionLoading(false);
    } catch (err) {
      console.log(err);
      setEditionLoading(false);
      setEditionLineList([]);
    }
  };

  const getTopAppids = (tableList: any[]) => {
    /** 取排除total的Top5 */
    const tableExceptTotal = tableList.filter((t: any) => t.name !== 'Total');
    const appIds = tableExceptTotal.map((t: any) => t.app_id);
    return appIds.slice(0, 5);
  };

  const changeEditionChartType = (value: string) => {
    setEditionChartType(value);
    editionChartTypeRef.current = value;

    if (value === 'line' || value === 'stackedLine') {
      const topAppids = getTopAppids(editionTableList);
      getEditionTrends(fetchParams, topAppids);
    }
  };

  const getTopMarketsRegions = (list: any[]) => {
    return getCountriesChartRequestMarketList(list);
  };

  const getMarketTrendRequestParams = (
    requestParams: any,
    countryType: string,
    markets: string[],
  ) => {
    return buildCountriesChartRequestParams(
      {
        ...requestParams,
        /** 后端getTop国家或地区，用regiontype区分国家或地区，regeions传国家或地区 */
        region_type: countryType,
        regions: markets,
      },
    );
  };

  const getCountry = async (params: any, countryType: string, updateFilterValues = filterValue) => {
    const newFetchParams = {
      ...fetchParams,
      ...params,
      region_type_share: countryType,
    };
    newFetchParams.app_ids = appIds;
    setFetchParams(newFetchParams);
    // setReqParamsDownLoad({ ...newFetchParams });
    setLoading(true);
    setChartLoading(true);
    const marketType = getMaketsType(newFetchParams.regions, newFetchParams.regions);
    setMarketType(marketType);
    try {
      const isUpdateShortLinkNow = !!newFetchParams?.start_date && !!newFetchParams?.end_date;
      // 时间如果是空的，则需要更新时间筛选器
      const needUpdateTime = !newFetchParams?.start_date || !newFetchParams?.end_date;
      if (isUpdateShortLinkNow && hasUrlShortLink) {
        updateShortLinkFilterId({ [URL_FILTER_KEY]: updateFilterValues, [URL_APP_IDS]: appIds });
      }

      // eslint-disable-next-line no-prototype-builtins
      if (newFetchParams.hasOwnProperty('app_ids') && !newFetchParams.app_ids?.length) {
        setMarketTableList([]);
        setMarketChartList([]);
        setMarketError(true);
        setChartLoading(false);
        setLoading(false);
        return;
      }

      const countryRes = await statsActiveuserMarketTable(
        getPageRequestParams(
          buildCountriesChartRequestParams(newFetchParams),
        ),
      );
      let startDate = '';
      let endDate = '';

      if (countryRes?.code === 0 && !!countryRes?.data) {
        // const totalList = countryRes?.data?.metrics_total || [];
        const tableList = countryRes?.data?.list || [];
        const sortData = sortTableByMetric({
          tableData: tableList,
          sortParams: {
            ratioType: 0,
            sortVal: 'desc',
            // sortMetric: getEditionCountrytMetricKey(pageId) || metricKey,
            sortMetric: chartSegment || metricKey,
          },
          timeProperty: 'time',
          metricProperty: 'metric',
          growthProperty: 'growth_ratio',
        });
        // tableList.unshift(totalList ? totalList || {} : {})
        const topListTmp = getTopList(sortData);
        const firstFixedData = getFixedTableData(marketType, topListTmp);
        setTopList(topListTmp);
        setMarketFixedTableData(firstFixedData);
        setMarketTableList(buildCountriesTableDisplayList(topListTmp.list));

        // setReqParamsDownLoad({
        //   ...newFetchParams,
        //   start_date: marketRes?.req?.start_date,
        //   end_date: marketRes?.req?.end_date,
        // });
        startDate = countryRes?.req?.start_date;
        endDate = countryRes?.req?.end_date;
        if (startDate && endDate) {
          newFetchParams.start_date = startDate;
          newFetchParams.end_date = endDate;
        } else {
          const [defautStart, defautEnd] = getDefaultTime(newFetchParams.date_type, isTwoMonths);
          newFetchParams.start_date = defautStart;
          newFetchParams.end_date = defautEnd;
        }
        setFetchParams(newFetchParams);

        const chartDisplayList = buildCountriesChartDisplayList(topListTmp.list);
        setMarketChartList(chartDisplayList);

        // 获取到时间后更新筛选器的值，并更新url短链接
        if (needUpdateTime && startDate && endDate) {
          const newFilterValue = updateTimeFilterValue({
            // hasUrlShortLinkVal,
            // haveFilterSaveBtn: true,
            // filterSaveName,
            filterValue: updateFilterValues,
            timeFilterValues: {
              type: newFetchParams.date_type,
              value: [newFetchParams.start_date, newFetchParams.end_date],
            },
          });
          setFilterVale(newFilterValue);
          // 如果是时间为空等时间返回更新 且有短链接功能，则更新短链接
          if (!isUpdateShortLinkNow && hasUrlShortLink) {
            updateShortLinkFilterId({ [URL_FILTER_KEY]: newFilterValue, [URL_APP_IDS]: appIds });
          }
        }
        // setMarketTotalList(totalList || []);
        if (
          // 表格有数据时才查询
          sortData?.length &&
          (marketChartTypeRef.current === 'line' || marketChartTypeRef.current === 'stackedLine')
        ) {
          const topMarketsRegions = getTopMarketsRegions(topListTmp.list);
          getCountryTrends(
            getMarketTrendRequestParams(newFetchParams, countryType, topMarketsRegions),
          );
        }
      } else {
        setMarketTableList([]);
        setMarketChartList([]);
      }
      setMarketError(false);
    } catch (err) {
      console.error(err);
      setMarketTableList([]);
      setMarketChartList([]);
      setMarketError(true);
    }
    setChartLoading(false);
    setLoading(false);
  };

  // 添加topList的传入，防止异步
  const getCountryTrends = async (params: any) => {
    setChartLineLoading(true);
    try {
      // 首次请求后就把折线图数据存起来， 点折线图图片就直接取； 只有改变筛选器时才重新请求
      const res = await statsActiveuserMarketTrend(
        getPageRequestParams(params),
      );
      const lineDataRes = res?.data?.trends || [];
      const lineDatas = buildCountriesChartDisplayList(lineDataRes);
      setMarketLineData(lineDatas);
      // setEarliestCountry(country);
    } catch (err) {}
    setChartLineLoading(false);
  };

  const changeMarketSegement = (value: 'market' | 'region') => {
    countryTypeRef.current = value;
    // 修改参数
    getCountry(fetchParams, value);
  };

  const handleConfirm = (value: any, filter) => {
    const newFetchParams = { ...fetchParams, ...value };
    // 获取页面接口
    getPageData(newFetchParams, filter);
    // 如果不是操作时间筛选器则请求最早时间接口，否则不请求接口
    if (
      value?.source !== fetchParams?.source ||
      value?.region_type !== fetchParams?.region_type ||
      value?.regions !== fetchParams?.regions
    ) {
      updateEarliestDateData({
        dataSources: [newFetchParams.source],
        metrics: [metricKey],
        regionType: newFetchParams.region_type,
        regions: newFetchParams.regions,
        dateType: newFetchParams.date_type,
        platforms: newFetchParams?.platforms,
      });
    } else {
      /** 时间筛选器类型切换时， */
      const { earliestDay, earliestPeriod } = getEarliestDayAndEarliesPeriod(
        newFetchParams.date_type,
        metricKey,
      );
      setEarliestDay(earliestDay);
      setEarliestPeriod(earliestPeriod);
    }
  };

  const changeMarketChartType = (value: string) => {
    setMarketChartType(value);
    marketChartTypeRef.current = value;
    if (value === 'line' || value === 'stackedLine') {
      const topMarketsRegions = getTopMarketsRegions(topList.list);
      getCountryTrends(
        getMarketTrendRequestParams(
          fetchParams,
          fetchParams.region_type_share,
          topMarketsRegions,
        ),
      );
    }
  };

  const handleRevenueScopeChange = (nextScope: string): void => {
    const newFilterValues = {
      ...filterValue,
      [filterKeyMap.REVENUE_SCOPE]: { value: nextScope },
    };
    setFilterVale(newFilterValues);
    setDetailFilterExtend(newFilterValues);
    handleConfirm({ revenue_scope: nextScope }, newFilterValues);
  };

  return (
    <>
      {enableRevenueScope ? (
        <MobileStatsRevenueScopePortal
          value={filterValue?.[filterKeyMap.REVENUE_SCOPE]?.value}
          onChange={handleRevenueScopeChange}
        />
      ) : null}
      <div className="dbi-statsfilter-warp">
        <div
          className={`statsfilter-warp-left${
            enableOpinionEvents ? ' dbi-mobile-stats-opinion-filter-wrap' : ''
          }`}
        >
          <Filter
            // timeFilterValues={{
            //   type: fetchParams.date_type,
            //   value: [fetchParams.start_date, fetchParams.end_date],
            // }}
            sinceReleaseTime={baseReleaseTimeValue}
            earliestDataTime={earliestPeriod}
            filterConfirm={handleConfirm}
            filterValue={filterValue}
            setFilterVale={setFilterVale}
            filterCfg={filterCfgWithOpinionEvent}
            defaultValue={DEFAULT_FORM_VALUE}
          />
          {enableOpinionEvents && pageId !== 'revenue'
            ? renderOpinionEventToolbar(opinionEventToolbar)
            : null}
          <TipContext
            AWidth={600}
            className="statsfilter-warp-filter-tip"
            tipText={formatMessage({ id: `dbi_stats_filter_dropdown_info` })}
          />
        </div>
        <div className="dbi-statsfilter-warp-right">
          <ExportTable
            entityType="mobile"
            tableParams={{
              ...fetchParams,
              segment: pageId,
              unified_id: gameId,
              unified_ids: [gameId],
            }}
            downloadTitleTips={DownloadTitleTips}
            businessType="mobile-stats-countries"
            isDisableDownload={loading}
            isShowMaxDownloadRowsTips={false}
            downloadModalSize={820}
            isDisableDataAmount={true}
            isCalibrated={isCalibrated}
            newStyleFileName={`${basicInfo?.name}${
              tabType === 'stats' ? '_Stats' : isCoutriesPage ? '_Countries' : ''
            }`}
            showDropdownBtnList={true}
            chartDownloadConfig={chartDownloadConfig}
            isCoutriesPage={isCoutriesPage}
            useWebDownload={true}
            downloadKey={'mobileCoutries'}
            downloadLogConfigKey={mobileStats?.[`${tabType}_${pageId}`]}
          />
        </div>
      </div>

      {isCoutriesPage ? (
        <CountriesCard
          pageId={pageId}
          loading={chartLoading}
          tableData={marketTableList}
          marketChartList={marketChartList}
          lineData={marketLineData}
          getRpdTypeData={getRpdTypeData}
          entityType={entityType}
          gameName={basicInfo?.name}
          gameCover={basicInfo?.cover}
          metric={'source'} // 没有指标切换的折线图metric都为'source'
          // unPublishedAppIdList={unPublishedAppIdList}
          dataSource={fetchParams.source}
          isDropdown={isDropdown}
          islowerGame={isPullOffGame}
          lowerGameTime={pullOffTime}
          showRankSwitch={showRankSwitch}
          regionsCountries={regionsCountries || []}
          cardStatus={{
            isLoading: loading || chartLoading,
            isError: marketError,
            isNoData: !marketTableList?.length,
          }}
          chartType={marketChartType}
          countriesType={countryTypeRef.current}
          setChartType={changeMarketChartType}
          changeSegement={changeMarketSegement}
          hasEarliestLogicInCurrentEntityType={hasEarliestLogicInCurrentEntityType}
          showReleaseDate={hasEarliestLogicInCurrentEntityType}
          showEarliestDate={hasEarliestLogicInCurrentEntityType}
          chartSegment={chartSegment}
          topList={topList}
          fixedTableData={marketFixedTableData}
          chartLoading={chartLoading}
          setChartLoading={setChartLoading}
          chartLineLoading={chartLineLoading}
          setChartLineLoading={setChartLineLoading}
          dateType={fetchParams.date_type}
          startDate={fetchParams?.start_date}
          endDate={fetchParams?.end_date}
          earliestLoading={earliestLoading}
          baseReleaseTime={baseReleaseTimeData}
          earliestPeriod={earliestPeriod}
          earliestDay={formattedEarliestDay}
          firstWeekSinceReleaseDates={firstWeekSinceReleaseDates}
          pageSortAttr={countriesPageSortAttr}
          onTableSortChage={onTableSortChageCountrie}
        />
      ) : (
        <>
          <TrendsCard
            pageId={pageId}
            metricKey={metricKey}
            tableData={trendTableList}
            lineData={trendLineList}
            isDropdown={isDropdown}
            showRankSwitch={showRankSwitch}
            entityType={entityType}
            gameName={basicInfo?.name}
            gameCover={basicInfo?.cover}
            dateType={fetchParams.date_type}
            startDate={fetchParams.start_date}
            endDate={fetchParams.end_date}
            trendComputeType={trendComputeType}
            trendCount={trendCount}
            dataSource={fetchParams.source}
            islowerGame={isPullOffGame}
            lowerGameTime={pullOffTime}
            dateValue={[fetchParams.start_date, fetchParams.end_date]}
            baseReleaseTime={baseReleaseTimeData}
            earliestPeriod={earliestPeriod}
            earliestDay={formattedEarliestDay}
            cardStatus={buildStatsCardStatus(
              {
                isLoading: loading || trendLoading,
                isError: trendError,
                isNoData: !trendTableList?.length,
              },
              pageId,
              isCoutriesPage,
            )}
            earliestLoading={earliestLoading}
            trendLoading={trendLoading}
            firstWeekSinceReleaseDates={firstWeekSinceReleaseDates}
            onTableSortChage={onTableSortChageTrend}
            pageSortAttr={trendPageSortAttr}
            trendRankSwitch={trendRankSwitch}
            setTrendRankSwitch={setTrendRankSwitch}
            enableOpinionEventAnnotation={enableOpinionEvents}
            controlledEventAnnotation={controlledEventAnnotation}
          />
          <EditionsShareCard
            pageId={pageId}
            tableData={editionTableList}
            editionLineList={editionLineList}
            unPublishedAppIdList={unPublishedAppIdList}
            dataSource={fetchParams.source}
            isDropdown={isDropdown}
            entityType={entityType}
            dateType={fetchParams.date_type}
            startDate={fetchParams?.start_date}
            endDate={fetchParams?.end_date}
            islowerGame={isPullOffGame}
            lowerGameTime={pullOffTime}
            showRankSwitch={showRankSwitch}
            cardStatus={buildStatsCardStatus(
              {
                isLoading: loading || editionLoading,
                isError: editionError,
                isNoData: !editionTableList?.length,
              },
              pageId,
              isCoutriesPage,
            )}
            chartType={editionChartType}
            setChartType={changeEditionChartType}
            lineData={lineData}
            basicInfo={basicInfo}
            fixedTableData={editonFixedTableData}
            pageSortAttr={editionPageSortAttr}
            onTableSortChage={onTableSortChageEdition}
            chartSegment={chartSegment}
            firstWeekSinceReleaseDates={firstWeekSinceReleaseDates}
          />
        </>
      )}
    </>
  );
};

export default connect((state: any) => ({
  topchartsState: state[DBI_TOPCHARTS],
}))(ActiveUserContext);
